import React from 'react';
import { Link } from 'react-router-dom';
import { useWheatCanvas } from '../../hooks/useWheatCanvas';
import ArrowIcon from '../shared/ArrowIcon';
import '../../styles/buttons.css';
import './Hero.css';
import './HeroCards.css';

function Hero() {
  const canvasRef = useWheatCanvas();

  return (
    <section className="hero">
      <div className="hero-canvas"><canvas ref={canvasRef} /></div>
      <div className="hero-overlay" />
      <div className="hero-grain" />
      <div className="hero-content">
        <div className="hero-text">
          <HeroBadge />
          <h1>
            Building Resilient<br />
            Communities in<br />
            <em>Harmony with Nature</em>
          </h1>
          <p className="hero-desc">
            At STUPA Developmental Foundation, we collaborate with diverse
            stakeholders to drive impactful change across Agriculture,
            Forestry, Livelihood Development, and Environmental Sustainability.
          </p>
          <HeroActions />
        </div>
        <HeroVisual />
      </div>
    </section>
  );
}

function HeroBadge() {
  return (
    <div className="hero-badge">
      <span className="hero-badge-dot" />
      Creating Sustainable Green Spaces
    </div>
  );
}

function HeroActions() {
  return (
    <div className="hero-actions">
      <Link to="/focus-area" className="btn-primary">
        Discover Our Work <ArrowIcon />
      </Link>
      <Link to="/our-story" className="btn-ghost">Our Story</Link>
    </div>
  );
}

function HeroVisual() {
  return (
    <div className="hero-visual">
      <div className="hero-float-circle" />
      <div className="hero-float-circle" />
      <div className="hero-card-stack">
        <HeroCardFocus />
        <HeroCardImpact />
        <HeroCardReach />
      </div>
    </div>
  );
}

function HeroCardFocus() {
  return (
    <div className="hero-card">
      <div className="hero-card-content">
        <div className="hero-card-label">Focus Area</div>
        <div className="hero-card-title">Climate Adaptive<br />Agriculture</div>
        <p className="hero-card-desc">
          Building resilient, regenerative, and sustainable agriculture
        </p>
      </div>
    </div>
  );
}

function HeroCardImpact() {
  return (
    <div className="hero-card">
      <div className="hero-card-content">
        <div className="hero-card-label">Impact</div>
        <div className="hero-card-stat">8</div>
        <div className="hero-card-stat-label">
          UN Sustainable Development Goals Aligned
        </div>
      </div>
    </div>
  );
}

function HeroCardReach() {
  return (
    <div className="hero-card">
      <div className="hero-card-content">
        <div className="hero-card-label">Our Reach</div>
        <div className="hero-card-title">Greening Landscapes</div>
        <p className="hero-card-desc">Rural &amp; Urban sustainability</p>
      </div>
    </div>
  );
}

export default Hero;
